import "@hotwired/turbo-rails"

document.addEventListener("turbo:load", function () {
  document.querySelector('body').classList.remove('hidden')
})

